<template>
  <div class="cs-videoAppointment-courseWeek">
    <pagination
      v-show="!!listData"
      v-loading="loading"
      :data="listData"
      :option="paginationOption"
      selectedKeyField="CourseActivationId"
      :selectedKey="dataIn.courseActivationId"
      @search="search"
      @loadData="onLoadList"
      @pageSizeChange="pageSizeChange"
      @currentPageChange="currentPageChange"
      @checkChange="onCheckChange"
    ></pagination>
  </div>
</template>

<style lang="scss">
.cs-videoAppointment-courseWeek {
 label{
   margin-bottom: 0;
 }
 th.el-table-column--selection{
   .el-checkbox{
     display: none;
   }
 }
}
</style>

<style lang="scss" scoped>
.cs-videoAppointment-courseWeek {
  padding: 0 10px 10px 0;
}
</style>

<script>
import pagination from "../common/pagination";
import { getCourseWeekListPageData } from "../../service/videoAppointment.service";
export default {
  props: {
    dataIn: {
      courseId: Number | String,
      courseActivationId: Number | String,
      isReviewCourse: Boolean
    }
  },
  data() {
    return {
      loading: false,
      listData: [],
      paginationOption: {},
      pageSize: 20,
      searchPhone: "",
    };
  },
  components: {
    pagination
  },
  created() {
    this.paginationOption = {
      displayPagination: false,
      hasEditButton: false,
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton: false,
      hasChecked: true,
      checkedColumnTite: ""
    };
    this.init();
  },
  methods: {
    init(){
      if (!!this.dataIn && !!this.dataIn.courseId){
        this.search();
      }
    },
    search(pageNumber) {
      let pageData = this.getSearchPageData(pageNumber);
      this.loadListData(pageData);
    },
    onLoadList(pageData) {
      this.search(pageData.pageNumber);
    },
    loadListData(pageData) {
      this.loading = true;
      getCourseWeekListPageData(pageData)
        .then(result => {
          if (!!result && result.success) {
            this.listData = result.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    pageSizeChange(value) {
      this.pageSize = value;
    },
    currentPageChange(value) {
      this.listData.CurrentPage = value;
    },
    getSearchPageData(pageNumber) {
      if (typeof pageNumber == "undefined") {
        pageNumber = 1;
      }

      let pageData = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        keyWord: this.dataIn.courseId,
        additionalFilter:{
          isReviewCourse: this.dataIn.isReviewCourse
        }
      };
      return pageData;
    },
    onCheckChange(row, isChecked) {
      this.$emit("selectWeek", row, isChecked);
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/addVideoAppointment/avappCourseWeek.vue